// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"427":"21769abfea83318d","651":"cfcb2e75a23a4597","836":"26d52accded800f2"}[chunkId] + ".js";
};